function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUsableArea(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M83.441 32.566C78.623 4.783 55.238 2.624 48.186 2.624c-1.062 0-1.821.046-2.195.076-10.803.067-31.614 6.314-34.216 29.606-1.715 15.349 3.641 30.809 15.488 44.709 8.792 10.314 18.007 16.134 18.396 16.377a3.997 3.997 0 004.418-.118c.396-.278 9.803-6.929 18.639-17.562C80.736 61.25 85.828 46.33 83.441 32.566zM47.667 85.063c-7.477-5.443-30.96-24.848-27.942-51.869 2.476-22.154 25.471-22.492 26.444-22.495.125 0 .264-.007.389-.019.006 0 .611-.056 1.628-.056 7.015 0 23.725 2.271 27.373 23.31 4.113 23.713-20.315 45.129-27.892 51.129z"
  }), React.createElement("path", {
    d: "M47.375 22C37.794 22 30 29.794 30 39.375S37.794 56.75 47.375 56.75 64.75 48.956 64.75 39.375 56.956 22 47.375 22zm0 26.75c-5.169 0-9.375-4.206-9.375-9.375S42.206 30 47.375 30s9.375 4.206 9.375 9.375-4.206 9.375-9.375 9.375z"
  }));
}

SvgUsableArea.clsName = 'icon-www__usable-area';
SvgUsableArea.remarkName = 'unknown';
export default SvgUsableArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/UsableArea.js
// module id = 2518
// module chunks = 17 18